<template>
    <div class="row">
        <b-card title="Member Birthday's" class="col">
            <b-card-body>
                <FullCalendar :options="calendarConfig" ref="birthdayCalendar" />
                <!-- <FullCalendar ref="fullCalendar" timeZone="UTC" :header="{left: '', center:'title', right: 'prev, next'}" :eventSources="calendarConfigRaw" defaultView="dayGridMonth" :firstDay="1" :eventTimeFormat="{hour: '2-digit', minute: '2-digit', meridiem: false, hour12: false}" :plugins="calendarPlugins" /> -->
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import listPlugin from '@fullcalendar/list';
import interactionPlugin from '@fullcalendar/interaction'
import bootstrapPlugin from '@fullcalendar/bootstrap';
import moment from 'moment-timezone';

export default {
    components: {
        FullCalendar // make the <FullCalendar> tag available
    },
    props: {
        calendarConfigRaw: {
            default: false,
        },
        mobile: {
            default: false,
        },
    },
    data() {
        return {
            calendarPlugins: [ dayGridPlugin ],
            calendarConfig: {
                plugins: [ dayGridPlugin, listPlugin, interactionPlugin, bootstrapPlugin ],
                themeSystem: 'bootstrap',
                initialView: this.mobile ? 'listMonth' : 'dayGridMonth',
                headerToolbar: {
                    start: '',
                    center:'title',
                    end: 'today prev,next'
                },
                handleWindowResize: true,
                eventSources: this.calendarConfigRaw,
                firstDay: 1,
                timeZone: "UTC",
                height: this.mobile ? 'auto' : null,
                showNonCurrentDates: false,
                eventTimeFormat: { // like '14:30:00'
                    hour: '2-digit',
                    minute: '2-digit',
                    meridiem: false,
                    hour12: false
                },
                displayEventTime: false,
                eventDidMount: function(info) {
                    let icon = document.createElement('i');
                    icon.classList.add('far', 'fa-fw', 'fa-birthday-cake');
                    if (info.el.querySelector('.fc-event-title')) {
                        info.el.querySelector('.fc-event-title').prepend(icon);
                    } else if (info.el.querySelector('.fc-list-event-title')) {
                        info.el.querySelector('.fc-list-event-title').prepend(icon);
                    }
                },
            },
            reloadInterval: false,
            member: {
                birthday: ''
            }
        }
    },
    methods: {},
    mounted() {
        this.reloadInterval = setInterval(() => {
            this.$refs.birthdayCalendar.getApi().refetchEvents();
        }, 60 * 1000);
    },
    beforeDestroy() {
        clearInterval(this.reloadInterval);
    },
}
</script>